import "./styles/App.css";
import moment from "moment";
import "moment/locale/vi";
import { BrowserRouter, Routes, Route, Outlet, useNavigate } from "react-router-dom";
import MainLayout from "./Layout";
import TrangChu from "./routes/trangquantri/trangchu";
import RoutesNhatKyHeThong from "./routes/NhatKyHeThong";
import RoutesQuanLyNguoiDung from "./routes/QuanTriHeThong/QuanLyNguoiDung";
import DanhMuc from "./routes/DanhMuc/index";
import { DanhMucList } from "./routes/DanhMuc/configMenu";
import RoutesCoSoPhanPhoi from "./routes/ThongTinSanXuat/CoSoPhanPhoi";
import RoutesCoSoSanXuat from "./routes/ThongTinSanXuat/CoSoSanXuat";
import RoutesDuLieuThongKe from "./routes/BaoCaoThongKe/DuLieuThongKe";
import RoutesDuLieuKhiHau from "./routes/BaoCaoThongKe/DuLieuKhiHau";
import RoutesBaoCaoChuyenDe from "./routes/BaoCaoThongKe/BaoCaoChuyenDe";
import RoutesCoSoCheBien from "./routes/ThongTinSanXuat/CoSoCheBien";
import RoutesSanPham from "./routes/SanPham";
import RoutesThongTinDoanhNghiep, { ThongTinDoanhNghiepTKDN } from "./routes/DoanhNghiep";
import RoutesVungSanXuat from "./routes/VungSanXuat";
import RoutesLoHang from "./routes/LoHang";
import RoutesLichSuSanXuat from "./routes/LichSuSanXuat";
import RoutesCauHinhHienThiSanPham from "./routes/QuanTriHeThong/CauHinhHienThiSanPham";
import RoutesQuanLySilde from "./routes/QuanTriHeThong/QuanLySilde";
import RoutesQuanLyTinTuc from "./routes/QuanTriHeThong/QuanLyTinTuc";
import BanDo from "./routes/BanDo/index.js";
import Login from "./routes/Auth/Login.js";
import { useSelector } from "react-redux";
import { commonReducerSelector, userSelector } from "./redux/selector";
import PageNotFound from "./routes/Auth/PageNotFound.js";
import { useEffect, useLayoutEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import userReducer from "./redux/slice/userSlice.js";
import { Box, CircularProgress } from "@mui/material";
import RoutesQuanLyNhomNguoiDung from "./routes/QuanTriHeThong/QuanLyNhomNguoiDung/index.js";
import RoutesPhanQuyenChucNang from "./routes/QuanTriHeThong/PhanQuyenChucNang/index.js";
import RoutesQuanLyNhomChucNang from "./routes/QuanTriHeThong/QuanLyNhomChucNang/index.js";
import RoutesQuanLyChucNang from "./routes/QuanTriHeThong/QuanLyChucNang/index.js";
import Helper from "./helpers.js";
import { maChucNang } from "./constants/constant.js";
import { getFunctionsByRole, getProfile } from "./services/apis/danhmuc-service.js";
import { isEmpty } from "lodash";
import Api, { setCurrentUser } from "./api2.js";
import { setCurrentUser2 } from "./api_danhmuc.js";
import RoutesThongTinLichSuSanXuat from "./routes/ThongTinLichSuSanXuat/index.js";
import RoutesThongTinLichSuCheBien from "./routes/ThongTinLichSuCheBien/index.js";
import RoutesThongTinLichSuPhanPhoi from "./routes/ThongTinLichSuPhanPhoi/index.js";
import ThongTinTaiKhoan from "./routes/QuanTriHeThong/ThongTinTaiKhoan/index.js";
import { ThongTinCoSoSanXuat } from "./routes/ThongTinCoSo/CoSoSanXuat/index.js";
import { ThongTinCoSoPhanPhoi } from "./routes/ThongTinCoSo/CoSoPhanPhoi/index.js";
import { ThongTinCoSoCheBien } from "./routes/ThongTinCoSo/CoSoCheBien/index.js";

moment.locale("vi");

function App() {
  const dispatch = useDispatch()
  const user = useSelector(userSelector)
  const [loading, setLoading] = useState(true);
  const common = useSelector(commonReducerSelector);
  const [profile, setProfile] = useState(null);

  const userPermissionObj = Helper.handleGroupFunctions(common?.functions?.data) || [];
  const userPermissions = Object.values(userPermissionObj).flat();
  const routesWithPermissions = [
    { path: "trangchu", element: <TrangChu />, maChucNang: maChucNang.TC },
    { path: "bando", element: <BanDo />, maChucNang: maChucNang.BANDO },
    { path: "danhmuc", element: <DanhMuc />, maChucNang: maChucNang.DANHMUC },
    { path: "danhmuc/:id", element: <DanhMuc />, maChucNang: maChucNang.DANHMUC },
    { path: "doanhnghiep/infor/:id", element: <ThongTinDoanhNghiepTKDN />, maChucNang: maChucNang.THONGTINDOANHNGHIEP },
    { path: "nhat-ky-he-thong", element: <Outlet />, maChucNang: maChucNang.NHATKYHETHONG, children: RoutesNhatKyHeThong },
    { path: "quantrihethong/quanlynguoidung", element: <Outlet />, maChucNang: maChucNang.QUANTRIHETHONG_QUANLYNGUOIDUNG, children: RoutesQuanLyNguoiDung },
    { path: "quantrihethong/quanlyslide", element: <Outlet />, maChucNang: maChucNang.QUANTRIHETHONG_QUANLYSLIDE, children: RoutesQuanLySilde },
    { path: "quantrihethong/quanlytintuc", element: <Outlet />, maChucNang: maChucNang.QUANTRIHETHONG_QUANLYTINTUC, children: RoutesQuanLyTinTuc },
    { path: "quantrihethong/cauhinhhienthithongtintruyxuat", element: <Outlet />, maChucNang: maChucNang.QUANTRIHETHONG_CAUHINHHIENTHISANPHAM, children: RoutesCauHinhHienThiSanPham },
    { path: "quantrihethong/quanlynhomnguoidung", element: <Outlet />, maChucNang: maChucNang.QUANTRIHETHONG_QUANLYNHOMNGUOIDUNG, children: RoutesQuanLyNhomNguoiDung },
    { path: "quantrihethong/phanquyenchucnang", element: <Outlet />, maChucNang: maChucNang.QUANTRIHETHONG_PHANQUYENCHUCNANG, children: RoutesPhanQuyenChucNang },
    { path: "quantrihethong/quanlynhomchucnang", element: <Outlet />, maChucNang: maChucNang.QUANTRIHETHONG_QUANLYNHOMCHUCNANG, children: RoutesQuanLyNhomChucNang },
    { path: "quantrihethong/quanlychucnang", element: <Outlet />, maChucNang: maChucNang.QUANTRIHETHONG_QUANLYCHUCNANG, children: RoutesQuanLyChucNang },
    { path: "thongtinsanxuat/cososanxuat", element: <Outlet />, maChucNang: maChucNang.THONGTINSANXUAT_COSOSANXUAT, children: RoutesCoSoSanXuat },
    { path: "thongtinsanxuat/cosophanphoi", element: <Outlet />, maChucNang: maChucNang.THONGTINSANXUAT_COSOPHANPHOI, children: RoutesCoSoPhanPhoi },
    { path: "thongtinsanxuat/cosochebien", element: <Outlet />, maChucNang: maChucNang.THONGTINSANXUAT_COSOCHEBIEN, children: RoutesCoSoCheBien },
    { path: "baocaothongke/dulieuthongke", element: <Outlet />, maChucNang: maChucNang.BAOCAOTHONGKE_DULIEUTHONGKE, children: RoutesDuLieuThongKe },
    { path: "baocaothongke/dulieukhihau", element: <Outlet />, maChucNang: maChucNang.BAOCAOTHONGKE_DULIEUKHIHAU, children: RoutesDuLieuKhiHau },
    { path: "baocaothongke/baocaochuyende", element: <Outlet />, maChucNang: maChucNang.BAOCAOTHONGKE_BAOCAOCHUYENDE, children: RoutesBaoCaoChuyenDe },
    { path: "sanpham", element: <Outlet />, maChucNang: maChucNang.SANPHAM, children: RoutesSanPham },
    { path: "thongtindoanhnghiep", element: <Outlet />, maChucNang: maChucNang.THONGTINDOANHNGHIEP, children: RoutesThongTinDoanhNghiep },
    { path: "vungsanxuat", element: <Outlet />, maChucNang: maChucNang.VUNGTRONG, children: RoutesVungSanXuat },
    { path: "lohang", element: <Outlet />, maChucNang: maChucNang.LOHANG, children: RoutesLoHang },
    { path: "lichsusanxuat", element: <Outlet />, maChucNang: maChucNang.LICHSUSANXUAT, children: RoutesLichSuSanXuat },
    { path: "thongtinlichsusanxuat", element: <Outlet />, maChucNang: maChucNang.THONGTINLICHSUSANXUAT, children: RoutesThongTinLichSuSanXuat },
    { path: "thongtinlichsuchebien", element: <Outlet />, maChucNang: maChucNang.THONGTINLICHSUCHEBIEN, children: RoutesThongTinLichSuCheBien },
    { path: "thongtinlichsuphanphoi", element: <Outlet />, maChucNang: maChucNang.THONGTINLICHSUPHANPHOI, children: RoutesThongTinLichSuPhanPhoi },
  ];
  const allowedRoutes = routesWithPermissions.filter(route =>
    userPermissions.includes(route.maChucNang)
  )

  useEffect(() => {
    let token = localStorage.getItem("accessToken")
    if (!user?.access_token) {
      setLoading(true)
      if (token) {
        // dispatch(userReducer.actions.setUserInfo({ token: token }));

        //todo check token
          new Api()
                .CheckToken(token)
                .then((data) => {
                    if (data.code !== 200) {
                      token = null;
                      localStorage.removeItem("accessToken");
                      dispatch(userReducer.actions.clearUserInfo());
                    }
                })
                .catch((err) => {});
              
        //if (check token true) -> set dispatch
        if (token) {
          dispatch(userReducer.actions.setUserInfo({ token: token }));
        }
      }
    }
    if (!user?.isLoggedIn && !token) {
      setLoading(false)
    }
  }, [])
  useEffect(() => {
      if (!isEmpty(user?.access_token)) {
        setCurrentUser(user);
        setCurrentUser2(user);
        // dispatch(getProfile(user));
        dispatch(getProfile({user: user, setLoading: setLoading, loading: loading}));
        dispatch(getFunctionsByRole(user));
      }
    }, [user]);    
  useEffect(() => {
    if (!isEmpty(userPermissions)) {
      setLoading(false)
    }
    if (!isEmpty(common?.profile?.data)){
      setProfile(common.profile.data)
    }
  }, [common])

  if (loading) {
    return (
      <div className="flat">
        <Box sx={{ display: "flex" }}>
          <CircularProgress />
        </Box>
      </div>
    );
  }
  return (
    <BrowserRouter basename="" innerRef={node => (window.globalRouter = node)}>
      <Routes>
        {!user.isLoggedIn && <Route index element={<Login />} />}
        {user.isLoggedIn &&
          <Route element={<MainLayout setLoading={setLoading} />}>
            <Route index element={<TrangChu />} />
            {/* <Route path="" index element={<TrangChu />} /> */}
            <Route path="thongtintaikhoan" index element={<ThongTinTaiKhoan userName={profile?.userName}/>} />
            <Route path="thongtincososanxuat" index element={<ThongTinCoSoSanXuat id={profile?.idCoSoSanXuat}/>} />
            <Route path="thongtincosochebien" index element={<ThongTinCoSoCheBien id={profile?.idCoSoCheBien}/>} />
            <Route path="thongtincosophanphoi" index element={<ThongTinCoSoPhanPhoi id={profile?.idCoSoPhanPhoi}/>} />
            {allowedRoutes.map((route, index) => (
              <Route key={index} path={route.path} element={route.element}>
                {route.children?.map((child, childIndex) => (
                  <Route key={childIndex} path={child.path} element={<child.main />} />
                ))}
              </Route>
            ))}
            {
              userPermissions.includes(maChucNang.DANHMUC) &&
              <Route path="danhmuc" element={<Outlet />}>
                {DanhMucList.map((item, index) => (
                  <Route path={item.path} key={index} element={<Outlet />}>
                    {item.childRoute?.map((route, childIndex) => (
                      <Route path={route.path} key={childIndex} element={<route.main />} />
                    ))}
                  </Route>
                ))}
              </Route>
            }
          </Route>
        }
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;